export class AppConstants {
  static readonly DEFAULT_PAGE_SIZE = 10;
  static readonly MAX_PAGE_SIZE = 1000;
  static readonly PAGE_OPTIONS = [10, 25, 50, 100];
  static readonly MAX_PAGES = 5;
  static readonly DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';
  static readonly DEFAULT_DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';
  static readonly DEFAULT_DEBOUNCE_TIME = 200;
  static readonly QUERY_DATE_FORMAT = 'YYYY-MM-DD';
}
